<template>
  <div class="wx-date-select">
    <span class="label2">{{ label }}</span>
    <DatePicker
      :value="date"
      @on-change="onPickerChange"
      type="daterange"
      format="yyyy-MM-dd"
      placement="bottom-start"
      placeholder="请选择时间范围"
      style="width: 260px"
      :clearable="false"
    ></DatePicker>
    <ul class="quick-menu">
      <li v-for="(item, idx) in quickOptions" :key="idx" @click="selectQuick(idx)">
        {{ item.label }}
      </li>
    </ul>
  </div>
</template>

<script>
import dayjs from "dayjs";

const QUICK_OPTIONS = [
  { label: "近1个月", days: 30 },
  { label: "近3个月", days: 90 },
  { label: "近6个月", days: 180 },
];

export default {
  name: "WxDateSelect",
  props: {
    label: {
      type: String,
      default: "时间范围：",
    },
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      date: this.value.length ? [...this.value] : [],
      quickOptions: QUICK_OPTIONS,
    };
  },
  watch: {
    value(val) {
      this.date = val ? [...val] : [];
    },
  },
  methods: {
    onPickerChange(value) {
      if (!value || !value[0] || !value[1]) return;
      const range = [
        dayjs(value[0]).format("YYYY-MM-DD"),
        dayjs(value[1]).format("YYYY-MM-DD"),
      ];
      this.date = range;
      this.$emit("input", range);
      this.$emit("change", range);
    },
    selectQuick(idx) {
      const { days } = this.quickOptions[idx];
      const end = dayjs().format("YYYY-MM-DD");
      const start = dayjs().subtract(days, "day").format("YYYY-MM-DD");
      const range = [start, end];
      this.date = range;
      this.$emit("input", range);
      this.$emit("change", range);
    },
  },
};
</script>

<style lang="scss" scoped>
.wx-date-select {
  position: relative;
  display: inline-flex;
  gap: 0;
  height: 32px;
  line-height: 32px;

  .label2 {
    font-size: 14px;
    color: #333;
  }

  .quick-menu {
    position: absolute;
    top: 100%;
    left: 72px; /* label 宽度 + gap */
    z-index: 2000;
    background: #fff;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    padding: 4px 0;
    margin: 0;
    display: none;
    white-space: nowrap;

    li {
      list-style: none;
      padding: 6px 14px;
      font-size: 13px;
      color: #333;
      cursor: pointer;
      transition: background 0.15s;

      &:hover {
        background: #f5f5f5;
        color: #0080ff;
      }
    }
  }

  &:hover .quick-menu {
    display: flex;
    gap: 0;
  }
}
</style>
